import React from "react";

export const RenewalNoticeReport = () => {
  return <div>RenewalNoticeReport</div>;
};
